import React, { useState } from 'react';
import { Input, Button, Modal, Spin } from 'antd';
import { useProcQualityForm } from './hooks/useProcQualityForm';

const { TextArea } = Input;

const P111JForm: React.FC = () => {
  const {
    mode, isEditing, loading,
    records, current, currentIdx,
    procCode, setProcCode,
    qualCode, setQualCode,
    desc, setDesc,
    navFirst, navPrev, navNext, navLast,
    startAdd, startEdit, cancel, save,
    doDelete, quickSearch,
  } = useProcQualityForm();

  const [searchText, setSearchText] = useState('');

  const handleDelete = () => {
    if (!current) return;
    Modal.confirm({
      title: '確認刪除',
      content: `確定要刪除工繳代號「${current.f11j_01}」品質要求「${current.f11j_02}」？`,
      okText: '刪除',
      okType: 'danger',
      cancelText: '取消',
      onOk: doDelete,
    });
  };

  const handleQuickSearch = () => {
    if (searchText.trim()) {
      quickSearch(searchText.trim());
    }
  };

  const modeLabel = mode === 'add' ? '新增' : mode === 'edit' ? '修改' : '瀏覽';

  return (
    <Spin spinning={loading}>
      <div className="max-w-2xl mx-auto p-6">
        {/* Title */}
        <h2 className="text-xl font-bold mb-4">
          工繳品質要求設定 (pw111jf1)
          <span className="ml-3 text-sm font-normal text-gray-500">
            [{modeLabel}] {records.length > 0 ? `${currentIdx + 1} / ${records.length}` : '無資料'}
          </span>
        </h2>

        {/* Quick Search Bar */}
        <div className="flex items-center gap-2 mb-4">
          <Input
            placeholder="輸入工繳代號快速查詢"
            value={searchText}
            onChange={e => setSearchText(e.target.value)}
            onPressEnter={handleQuickSearch}
            disabled={isEditing}
            style={{ width: 300 }}
            maxLength={6}
          />
          <Button onClick={handleQuickSearch} disabled={isEditing}>查詢</Button>
        </div>

        {/* Navigation Bar */}
        <div className="flex items-center gap-1 mb-4">
          <Button size="small" onClick={navFirst} disabled={isEditing || records.length === 0}>|&lt;</Button>
          <Button size="small" onClick={navPrev} disabled={isEditing || currentIdx <= 0}>&lt;</Button>
          <Button size="small" onClick={navNext} disabled={isEditing || currentIdx >= records.length - 1}>&gt;</Button>
          <Button size="small" onClick={navLast} disabled={isEditing || records.length === 0}>&gt;|</Button>
        </div>

        {/* Form Fields */}
        <div className="space-y-4 mb-6">
          <div>
            <label className="block text-sm font-medium text-gray-700 mb-1">工繳代號 (F11J_01)</label>
            <Input
              value={procCode}
              onChange={e => setProcCode(e.target.value)}
              maxLength={6}
              disabled={!isEditing || mode === 'edit'}
              style={{ width: 200 }}
              placeholder="最多6字元"
            />
          </div>
          <div>
            <label className="block text-sm font-medium text-gray-700 mb-1">品質要求代號 (F11J_02)</label>
            <Input
              value={qualCode}
              onChange={e => setQualCode(e.target.value)}
              maxLength={2}
              disabled={!isEditing || mode === 'edit'}
              style={{ width: 120 }}
              placeholder="最多2字元"
            />
          </div>
          <div>
            <label className="block text-sm font-medium text-gray-700 mb-1">品質要求說明 (F11J_11)</label>
            <TextArea
              value={desc}
              onChange={e => setDesc(e.target.value)}
              disabled={!isEditing}
              rows={4}
              style={{ width: 500 }}
              placeholder="品質要求說明"
            />
          </div>
        </div>

        {/* Audit Fields (read-only) */}
        {current && mode === 'browse' && (
          <div className="text-xs text-gray-400 mb-6 space-y-1">
            <div>建立人員: {current.f11j_91} | 建立日期: {current.f11j_92 || '-'}</div>
            <div>修改人員: {current.f11j_93}</div>
          </div>
        )}

        {/* Action Buttons */}
        <div className="flex items-center gap-2">
          {!isEditing ? (
            <>
              <Button type="primary" onClick={startAdd}>新增</Button>
              <Button onClick={startEdit} disabled={!current}>修改</Button>
              <Button danger onClick={handleDelete} disabled={!current}>刪除</Button>
            </>
          ) : (
            <>
              <Button type="primary" onClick={save}>儲存</Button>
              <Button onClick={cancel}>取消</Button>
            </>
          )}
        </div>
      </div>
    </Spin>
  );
};

export default P111JForm;
